import { Link } from "react-router-dom";
import { withApollo } from "react-apollo";
import React from "react";
import { getListofMasterQuery } from "../../../services/graphql/queries/masters";
import { PAGINATION_OFFSET_VALUE } from "../../../constants/app-constants";
import Pagination from "../../Common/Pagination";
import MasterFilter from "./MasterFilter";
import view from "../../../static/images/svg/view.svg";
class MastersList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageOfItems: [],
      showFilter: false,
      loading: true,
      error: "",
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,
      description: "",
    };
    this.filterAction = this.filterAction.bind(this);
    this.onFilterData = this.onFilterData.bind(this);
    this.filterOnChange = this.filterOnChange.bind(this);
  }
  onChangePage(currentPage) {
    this.state.currentPage = currentPage;
    this.getMaster();
  }
  onFilterData(data) {
    console.log("filter data", data);
    this.setState({ pageOfItems: data });
  }
  filterOnChange(data) {
    this.setState(
      {
        description: data.description,
        currentPage: data.currentPage,
      },
      () => {
        this.getMaster();
      }
    );
  }
  filterAction() {
    this.setState((prevState) => {
      return {
        showFilter: !prevState.showFilter,
      };
    });
  }
  getMaster() {
    this.props.client
      .query({
        query: getListofMasterQuery,
        variables: {
          descriptionName: this.state.description.trim(),
          offset: this.state.offset,
          pageNo: this.state.currentPage,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const master = result.data.getListofMaster;
        this.setState({
          pageOfItems: master,
          loading: false,
          error: "",
        });
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }
  componentDidMount() {
    this.getMaster();
  }
  render() {
    const masterData = this.state.pageOfItems;
    const { loading, error } = this.state;
    return (
      <>
        <div className="row align-items-center no-gutters">
          <div className="col-md-6">
            <h1 className="heading m-b-0">Generic Master </h1>
          </div>

          <div className="col-md-6 text-right">
            <button
              className="btn btn-primary filter-btn  m-l-10"
              onClick={this.filterAction}
            >
              Filter
            </button>

            <MasterFilter
              showFilter={this.state.showFilter}
              listData={this.onFilterData}
              filterAction={() => {
                this.state.showFilter = false;
              }}
              filterOnChange={this.filterOnChange}
            />
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-style-1 ">
            <thead>
              <tr>
                {/* <th scope="col">ID</th> */}
                <th scope="col">DESCRIPTION</th>
                <th scope="col">MASTER ENTRY</th>
                <th scope="col">STATUS VIEW</th>
              </tr>
            </thead>

            <tbody>
              {masterData.length
                ? masterData.map((data, index) => {
                    return (
                      <tr key={index}>
                        {/* <td>{data.Id} </td> */}
                        <td>{data.description} </td>
                        {data.allowmastersEntry ? (
                          <td>
                            <Link
                              to={`/genericmaster-list?id=${data.Id}&name=${data.description}`}
                            >
                              <a
                                className="link-primary link-section"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="Master Entry"
                              >
                                <img src={view} />
                              </a>
                            </Link>
                          </td>
                        ) : (
                          <td />
                        )}
                        {data.allowforStatus ? (
                          <td>
                            <Link
                              to={`/status-list?id=${data.Id}&name=${data.description}`}
                            >
                              <a
                                className="link-primary link-section"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="View"
                              >
                                <img src={view} />
                              </a>
                            </Link>
                          </td>
                        ) : (
                          <td />
                        )}
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
        </div>
        {!masterData.length && error ? <div>Error !!!</div> : null}
        {!masterData.length && loading ? <div>Fetching...</div> : null}
        {!masterData.length && !error && !loading ? (
          <div style={{ textAlign: "center" }}>No Data</div>
        ) : null}

        <Pagination
          loading={loading}
          items={masterData}
          pageSize={this.state.offset}
          initialPage={this.state.currentPage}
          onChangePage={this.onChangePage.bind(this)}
        />
      </>
    );
  }
}
export default withApollo(MastersList);
